/** Physiofit company contact, legal URLs, and insurer hotlines. */
export const companyConfig = {
  website: {
    url: 'https://www.physiofit.app',
  },
  support: {
    email: 'support@physiofit.app',
    hotline: {
      display: '+49 89 12086364',
      tel: 'tel:+498912086364',
    },
    insuranceNotFoundArticleUrl:
      'https://chatwoot.help/hc/physiofit-app/articles/1790072138-ich-finde-meine-krankenversicherung-nicht-_-was-tun',
  },
  legal: {
    /** Invoice consent checkbox — Datenschutzbedingungen */
    privacyUrl: 'https://physiofitapp.notion.site/Datenschutzerkl-rung-PHYSIOFIT-App-9fa0d2125f7b41bcb188c83181af7111?pvs=4',
    /** Invoice consent checkbox — Zahlungsbedingungen der Kursgebühr */
    courseFeePaymentTermsUrl: '',
    /** Invoice consent checkbox — Haftung (Ausschluss der Haftung) */
    liabilityUrl: '',
  }
} as const;
